import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.translations.json';

// the translations
const resources = {
  en: {
    translation: enTranslations,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en',

    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: false, // allows the use of colons (:) in translations
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
